import * as React from "react";

export const SharedIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M5.833 3v1.667H1.667v9.166h9.166V9.667H12.5v5a.833.833 0 0 1-.833.833H.833A.833.833 0 0 1 0 14.667V3.833A.833.833 0 0 1 .833 3h5ZM15 .5v6.667h-1.667V3.344L6.84 9.84 5.661 8.661l6.493-6.494h-3.82V.5H15Z"
    />
  </svg>
);
